// src/components/CookieBanner/CookieBanner.jsx
import React, { useState, useEffect } from "react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setIsVisible(true);
    } else {
      applyConsent(consent);
    }
  }, []);

  const applyConsent = (consent) => {
    if (!window.gtag) return;

    if (consent === "accepted") {
      window.gtag("consent", "update", {
        analytics_storage: "granted"
      });
    } else {
      window.gtag("consent", "update", {
        analytics_storage: "denied"
      });
    }
  };

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    applyConsent("accepted");
    setIsVisible(false);

    // 🔥 GA4 event – käyttäjä hyväksyi evästeet
    if (window.gaEvent) {
      window.gaEvent("evasteet_hyvaksytty");
    }
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    applyConsent("declined");
    setIsVisible(false);

    // 🔥 GA4 event – käyttäjä hylkäsi evästeet
    if (window.gaEvent) {
      window.gaEvent("evasteet_hylatty");
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className="
        fixed bottom-0 left-0 w-full
        bg-joyrideLight dark:bg-joyrideNavy
        text-black dark:text-joyrideLight
        p-4
        shadow-lg
        dark:shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.5)]
        z-50
      "
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between">
        <p className="text-sm mb-2 md:mb-0 text-center dark:text-shadow-sm">
          Tämä sivusto käyttää evästeitä kävijätilastojen keräämiseen ja
          käyttökokemuksen parantamiseen. Hyväksymällä autat meitä kehittämään
          Joyriden sivustoa.{" "}
          <a
            href="/privacy"
            className="underline hover:text-joyridePurple dark:hover:text-joyrideCyan"
          >
            Lue lisää
          </a>
          .
        </p>
        <div className="flex gap-2">
          <button
            onClick={declineCookies}
            className="px-4 py-2 rounded-lg border border-gray-400 hover:bg-gray-100 dark:hover:bg-joyridePurple transition"
          >
            Hylkää
          </button>
          <button
            onClick={acceptCookies}
            className="px-4 py-2 rounded-lg bg-joyridePurple text-white hover:bg-joyrideCyan transition"
          >
            Hyväksy
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
